import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class NotFound extends Component {
	render() {
		return (
			<div className="container-fluid">
				<div className="block-header">
					<div className="row">
						<div className="col-lg-12 col-md-12 col-sm-12">
							<h2>404 Error</h2>
							<ul className="breadcrumb">
								<li className="breadcrumb-item"><Link to="/">BrandSek</Link></li>
								<li className="breadcrumb-item active">404 Error</li>
							</ul>
						</div>
					</div>
				</div>

				<div className="row clearfix">
					<div className="col-lg-12">
						<div className="card">
							<div className="body text-center" style={{ padding: '60px 40px' }}>
								{/* 404 Number */}
								<div style={{
									fontSize: '150px',
									fontWeight: '700',
									color: '#e3e7ed',
									lineHeight: '1',
									marginBottom: '20px',
									fontFamily: 'Montserrat, sans-serif'
								}}>
									404
								</div>

								{/* Title */}
								<h2 style={{
									fontSize: '36px',
									fontWeight: '600',
									color: '#495057',
									marginBottom: '15px'
								}}>
									Page Not Found
								</h2>

								{/* Description */}
								<p style={{
									fontSize: '18px',
									color: '#6c757d',
									marginBottom: '40px',
									maxWidth: '500px',
									margin: '0 auto 40px auto',
									lineHeight: '1.6'
								}}>
									The page you are looking for might have been removed, 
									had its name changed, or is temporarily unavailable.
								</p>

								{/* Action Buttons */}
								<div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
									<Link 
										to="/" 
										className="btn btn-primary btn-round"
										style={{
											padding: '12px 30px',
											fontSize: '16px',
											fontWeight: '500',
											minWidth: '160px'
										}}
									>
										<i className="fa fa-home mr-2"></i>
										Go to Dashboard
									</Link>
								</div>

							

								{/* Decorative icon */}
								<div style={{
									position: 'absolute',
									top: '20px',
									right: '20px',
									fontSize: '24px',
									color: '#e9ecef',
									opacity: '0.5'
								}}>
									<i className="fa fa-exclamation-triangle"></i>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}
